module.exports = __webpack_public_path__ + "img/kjdsicon@2X.b7480eab.png";